import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import StatusMessages from '../../components/StatusMessages';
import BlankState from '../../components/BlankState';
import Page from '../../components/Page';
import DataTable from '../../components/DataTable';
import { TabHolder, Tab } from '../../components/Tabs';

import {
  saveUser,
  saveAdmin,
  listAdmins,
  updateUser
} from '../../actions/user';
import { listInsurers } from '../../actions/insurers';

import SimpleReactValidator from 'simple-react-validator';

class UsersPermissions extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.state = {
      users_loading: true,
      newUser: {
        first_name: '',
        last_name: '',
        other_names: '',
        postal_address: '',
        username: '',
        insurer: '',
        email: '',
        phone: '',
        type: ''
      },
      thisUser: {},
      active_user: {}
    };

    this.onChange = this.onChange.bind(this);
    this.createUser = this.createUser.bind(this);
  }

  editUser(user) {
    this.setState({ active_user: user });
  }

  componentDidMount() {
    const { listInsurers, listAdmins } = this.props;
    const insurer = this.props.user ? this.props.user.userInfo.insurer : null;
    listInsurers();
    listAdmins(insurer);
  }
  onChange2 = user => {
    const { thisUser } = this.state;
    const userInfo = user.user;
    const is_active = userInfo.is_active;
    this.setState(
      {
        thisUser: {
          ...user,
          user: {
            ...userInfo,
            is_active: !is_active
          }
        }
      },
      () => {
        this.props.updateUser(this.state.thisUser).then(() => {
          const insurer = this.props.user
            ? this.props.user.userInfo.insurer
            : null;
          this.props.listAdmins(insurer);
        });
      }
    );
  };

  onChange = e => {
    e.preventDefault();
    const { newUser } = this.state;
    const { name, value } = e.target;

    this.setState({
      newUser: {
        ...newUser,
        [name]: value
      }
    });
  };

  createUser = e => {
    e.preventDefault();
    const { newUser } = this.state;
    const { saveAdmin, user, listAdmins } = this.props;
    newUser.insurer = user.userInfo.insurer || newUser.insurer;
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      saveAdmin({
        user: {
          first_name: newUser.first_name,
          last_name: newUser.last_name,
          other_names: newUser.other_names,
          postal_address: newUser.postal_address,
          email: newUser.email,
          username: newUser.username,
          phone: newUser.phone,
          is_active: 'True'
        },
        profile: {
          company: newUser.insurer,
          insurer_admin_role: newUser.type
        },
        type: newUser.type.toLowerCase()
      });
      listAdmins(
        !!JSON.parse(sessionStorage.user).insurer
          ? JSON.parse(sessionStorage.user).insurer
          : null
      );
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  onUpdateUser = e => {
    e.preventDefault();

    const { active_user, user } = this.state;

    const updatedUser = {
      id: active_user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      insurer_admin_role: user.insurer_admin_role,
      date_joined: user.date_joined
    };

    this.props.updateUser(updatedUser);
  };

  render() {
    const _insurer = this.props.user ? this.props.user.userInfo.insurer : null;
    //get current logged in user
    const currentUser = this.props.user ? this.props.user.userInfo.id : null;

    const { insurers, user } = this.props; //pass onSubmit from

    const menuItems = [
      { id: 'admins', name: 'All Admins', active: true },
      { id: 'create-admin', name: 'Create Admin' }
    ];

    let { newUser } = this.state;
    //Exclude logged in user from list of admins
    const admins = user.admins;
    const otherAdmins = admins.filter(admin => {
      return admin.user.id != currentUser;
    });

    return (
      <Page isAdminPage={true} pageTitle="Users and Permissions">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              {user.admins.length > 0 ? (
                <DataTable
                  tableId="admins-table"
                  columnTitles={[
                    'First Name',
                    'Last Name',
                    'Insurance Company',
                    'Date Created',
                    'Actions'
                  ]}
                >
                  {otherAdmins.map((user, index) => {
                    return (
                      <tr key={index}>
                        <td>{user.user.first_name}</td>
                        <td>{user.user.last_name}</td>
                        <td>{user.company_name}</td>
                        <td>{user.user.date_joined}</td>
                        <td>
                          <button
                            className={
                              user.user.is_active === true
                                ? 'btn btn-danger btn-sm'
                                : 'btn btn-success btn-sm'
                            }
                            onClick={() => this.onChange2(user)}
                          >
                            {user.user.is_active === true
                              ? 'De-Activate'
                              : 'Activate'}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={user.admins}
                  dataName="Admins"
                  isDataLoading={user.adminsLoading}
                />
              )}
            </Tab>

            <Tab menuId={menuItems[1].id}>
              {user.errorCreateUserAdmin ? (
                <StatusMessages
                  type="error"
                  message={user.errorMessageCreateUserAdmin}
                />
              ) : null}
              {user.success ? (
                <StatusMessages type="success" message={user.successMessage} />
              ) : null}
              <form
                className="form-horizontal"
                noValidate
                onSubmit={this.createUser}
              >
                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    First Name: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      onChange={this.onChange}
                      name="first_name"
                      value={newUser.first_name}
                      className="form-control"
                      required
                    />
                    {this.validator.message(
                      'first_name',
                      newUser.first_name,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Last Name: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      onChange={this.onChange}
                      name="last_name"
                      value={newUser.last_name}
                      className="form-control"
                      required
                    />
                    {this.validator.message(
                      'last_name',
                      newUser.last_name,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Other Names:<span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      onChange={this.onChange}
                      name="other_names"
                      type="text"
                      value={newUser.other_names}
                      className="form-control"
                    />
                    {this.validator.message(
                      'other_names',
                      newUser.other_names,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Postal Address:<span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      onChange={this.onChange}
                      name="postal_address"
                      type="text"
                      value={newUser.postal_address}
                      className="form-control"
                    />
                    {this.validator.message(
                      'postal_address',
                      newUser.postal_address,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    ROLE: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control"
                      value={newUser.type}
                      onChange={this.onChange}
                      name="type"
                    >
                      <option value="" disabled>
                        Select Insurer Admin role
                      </option>
                      <option value="UNDERWRITER_ADMIN">
                        Underwriter Admin
                      </option>
                      <option value="INSURER_ADMIN">Super Admin</option>
                      <option value="SALES_ADMIN">Sales Admin</option>
                      <option value="FINANCE_ADMIN">Finance Admin</option>
                      <option value="BRANCH_ADMIN">Branch Admin</option>
                      <option value="BRANCH_UNDERWRITER_ADMIN">
                        Branch Underwriter Admin
                      </option>
                    </select>
                    {this.validator.message(
                      'type',
                      newUser.type,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                {_insurer ? null : (
                  <div className="form-group">
                    <label className="col-sm-4 control-label">
                      Insurers: <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                      <select
                        className="form-control"
                        name="insurer"
                        value={newUser.insurer}
                        onChange={this.onChange}
                      >
                        <option value="">Select Insurer</option>
                        {insurers &&
                          insurers.insurers.map((insurer, index) => {
                            return (
                              <option key={index} value={insurer.id}>
                                {insurer.company_name}
                              </option>
                            );
                          })}
                      </select>
                      {this.validator.message(
                        'insurer',
                        newUser.insurer,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Phone Number: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      onChange={this.onChange}
                      value={newUser.phone}
                      className="form-control"
                      name="phone"
                      required
                    />
                    {this.validator.message(
                      'phone',
                      newUser.phone,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Username: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      onChange={this.onChange}
                      value={newUser.username}
                      className="form-control"
                      name="username"
                      required
                    />
                    {this.validator.message(
                      'username',
                      newUser.username,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-4 control-label">
                    Email: <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      onChange={this.onChange}
                      value={newUser.email}
                      className="form-control"
                      name="email"
                      required
                    />
                    {this.validator.message(
                      'email',
                      newUser.email,
                      'required',
                      'text-danger'
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <div className="col-sm-8 col-md-offset-4">
                    <button type="submit" className="btn btn-success">
                      <i className="icon ion-checkmark" />Create Insurer Admin
                    </button>
                  </div>
                </div>
              </form>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  insurers: state.insurers
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveUser, saveAdmin, listInsurers, listAdmins, updateUser },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPermissions);



// WEBPACK FOOTER //
// ./src/pages/dashboard/UsersPermissions.jsx